<template>
  <div id="content" class="myAccount">

    <div class="container">
      <div class="myAccountContent">
        <div class="row ">
          <div class="">
            <span class="title">Projects pipeline</span>
            <div class="row mt50">
              <v-data-table :headers="headers" :items="filteredDesserts" item-key="name" class="elevation-1 pa-6" >
                <template v-slot:top>
               <!-- v-container, v-col and v-row are just for decoration purposes. -->
               <v-container fluid>
                   <v-row>

                       <v-col cols="4">
                           <v-row class="pa-6">
                               <!-- Filter for dessert name-->
                               <v-text-field v-model="filterProject" clearable type="text" label="Project name"></v-text-field>
                           </v-row>
                       </v-col>

                       <v-col cols="4">
                           <v-row class="pa-6">
                               <!-- Filter for dessert name-->
                               <v-text-field v-model="filterCustomer" clearable type="text" label="Customer name"></v-text-field>
                           </v-row>
                       </v-col>

                       <v-col cols="4">
                           <v-row class="pa-6">
                               <!-- Filter for calories -->
                               <v-autocomplete v-model="filterExpert" :items="experts_list" clearable item-color="#FFF" item-title="name" item-value="_id" label="Associated expert" ></v-autocomplete>

                           </v-row>
                       </v-col>

                   </v-row>
               </v-container>

           </template>
           <template v-slot:[`item.id`]="{  }">

             </template>
             <template v-slot:[`item.name`]="{ item }">
              <router-link :to="'/admin/project/'+item.columns.id.$oid" class="projectName">   {{item.columns.name}}</router-link>
               </template>
                  <template v-slot:[`item.customer`]="{ item }">
                    {{item.columns.customer.firstname}} {{item.columns.customer.lastname}}
                    </template>
                    <template v-slot:[`item.business_challenge`]="{ item }">
                      <v-badge v-if="item.columns.business_challenge == true" color="info" content="Yes" inline></v-badge>
                      <v-badge v-else color="warning" content="No" inline></v-badge>
                      </template>

                      <template v-slot:[`item.scouting_challenge`]="{ item }">
                        <v-badge v-if="item.columns.scouting_challenge == true" color="info" content="Yes" inline></v-badge>
                        <v-badge v-else color="warning" content="No" inline></v-badge>
                        </template>

                        <template v-slot:[`item.assessment_challenge`]="{ item }">
                          <v-badge v-if="item.columns.assessment_challenge == true" color="info" content="Yes" inline></v-badge>
                          <v-badge v-else color="warning" content="No" inline></v-badge>

                          </template>
                    <template v-slot:[`item.expert`]="{ item }">
                      <span v-if="item.columns.expert">{{item.columns.expert.firstname}} {{item.columns.expert.lastname}}</span>
                      <v-autocomplete v-else v-model="item.columns.expert" :items="experts_list"  item-color="#FFF" item-title="name" item-value="_id"  @update:modelValue="(event) => onChange(event, item.columns)" :disabled="item.columns.isOpen == false"></v-autocomplete>

                      </template>

                      <template v-slot:[`item.status`]="{ item }">
                        <v-badge v-if="item.columns.status == true" color="danger" content="Closed" inline></v-badge>
                        <v-badge v-else color="green" content="Open" inline></v-badge>
                        </template>

                        <template v-slot:[`item.createAt`]="{ item }">
                           <span v-if="item.columns.createAt">  {{ $filters.formatDateUS(item.columns.createAt.date) }}</span>

                          </template>

              </v-data-table>

              <!-- <vue3-datatable :rows="myProjects" :columns="headers"  :loading="loading" :sortable="true" :columnFilter="true" class="advanced-table whitespace-nowrap">
                <template #name="project">
                  <router-link :to="'/admin/project/'+project.value._id.$oid" class="submenu_link" >
                    <span class="small_menu_title">{{project.value.name}}</span>
                  </router-link>
               </template>
                <template #customer="project">
                    {{project.value.customer.firstname}} {{project.value.customer.lastname}}
               </template>

           <template #status="project">
             <v-badge v-if="project.value.isSubmit == true" color="danger" content="Closed" inline></v-badge>
             <v-badge v-else color="green" content="Open" inline></v-badge>
          </template>
          <template #expert="project">
            <v-autocomplete v-model="project.value.expert" :items="experts_list"  item-color="#FFF" item-title="name" item-value="_id"  @update:modelValue="(event) => onChange(event, project.value)" :disabled="project.value.isOpen == false"></v-autocomplete>


         </template>
              </vue3-datatable> -->
            </div>

            <!-- <table class="table mt20">
              <thead>
                <tr>
                  <th>Project name</th>
                  <th>Customer</th>
                  <th>Business Challenge</th>
                  <th>Scouting Challenge</th>
                  <th>Assessment Challenge</th>
                  <th>Expert associated</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(project,p) in myProjects" :key="p">
                  <td>
                    <router-link :to="'/admin/project/'+project._id.$oid" class="submenu_link" >
                      <span class="small_menu_title">{{project.name}}</span>
                    </router-link>
                  </td>
                  <td>
                      <span class="small_menu_title">{{project.customer.firstname}} {{project.customer.lastname}}</span>
                  </td>
                  <td>
                    <v-badge v-if="project.challenges.business_challenge == true" color="info" content="Yes" inline></v-badge>
                    <v-badge v-else color="warning" content="No" inline></v-badge>
                  </td>
                  <td>
                    <v-badge v-if="project.challenges.scouting_challenge == true" color="info" content="Yes" inline></v-badge>
                    <v-badge v-else color="warning" content="No" inline></v-badge>
                  </td>
                  <td>
                    <v-badge v-if="project.challenges.assessment_challenge == true" color="info" content="Yes" inline></v-badge>
                    <v-badge v-else color="warning" content="No" inline></v-badge>
                  </td>
                  <td>
                    <v-autocomplete v-model="project.expert" :items="experts_list"  item-color="#FFF" item-title="name" item-value="_id"  @update:modelValue="(event) => onChange(event, project)"></v-autocomplete>
                  </td>
                  <td>

                  </td>
                </tr>
              </tbody>
            </table> -->
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
 // import AddCommentModal from '@/components/modals/addComment.vue'
 // import NewValueModal from '@/components/modals/addValue.vue'
   // import AddSomeThingLink from '@/components/AddSomeThingLink.vue'
// import BookACall from '@/components/bookacall.vue'
import { toast } from 'vue-sonner'
import api from '@/tools/api';
//import StartupInfoLine from '@/components/InfoStartupLine.vue'
// import Vue3Datatable from "@bhplugin/vue3-datatable";
// import "@bhplugin/vue3-datatable/dist/style.css";
  import { VDataTable } from 'vuetify/labs/VDataTable'
export default {
  components: {
    // Vue3Datatable,
    VDataTable
    //StartupInfoLine,
    // AddSomeThingLink
    // Toaster,
    // BookACall
  },
  data() {
    return {
      pageInfo: {
        mainTitle : "My dashboard space",
        subTitle : "Monitor progress and manage next steps",
      },
       refreshKey: 0,
      filterProject:"",
filterCustomer:"",
filterExpert:  -1,
      loading: false,
      search : "",
      userInfo: {},
      myProjects: [],
      headers: [
        {
              title: '#',
             align: 'left',
             sortable: false,
             value: '_id',
             key:"id",
             type:"string",
        },
        {
              title: 'Project name',
             align: 'left',
             sortable: false,
             value: 'name',
             key:"name",
             type:"string",
        },
        {
            title: 'Customer',
             align: 'left',
             sortable: false,
             value: 'customer',
             key: 'customer'
        },
        {
            title: 'Business challenge',
             align: 'left',
             sortable: false,
             value: 'challenges.business_challenge',
             key: 'business_challenge',
        },
        {
            title: 'Scouting challenge',
             align: 'left',
             sortable: false,
             value: 'challenges.scouting_challenge',
              key: 'scouting_challenge',
        },
        {
            title: 'Assessment challenge',
             align: 'left',
             sortable: false,
             value: 'challenges.assessment_challenge',
              key: 'assessment_challenge',
        },
        {
            title: 'Expert',
             align: 'left',
             sortable: false,
             value: 'expert',
            key: 'expert'
        },

        {
            title: 'Status',
             align: 'left',
             sortable: false,
             value: 'isSubmit',
                key: 'status'
        },
        {
            title: 'Created at',
             align: 'left',
             sortable: false,
             value: 'createAt',
                key: 'createAt'
        },
      ],
      experts_list: [
        {
          _id:-1,
          name: "Not assigned",
        },
      ]
    }
  },
  methods:{
    gobackrouter : function(){
      this.$router.go(-1);
    },
    onChange: function(expert_id,project){
      console.log(project);

      //look for a solution to not notify if the same value is set
     api.post(process.env.VUE_APP_API_URL+"/restrict/set_expert",{
       project: project.id,
      expert: expert_id
      },{
          headers: {
              'Content-Type': 'application/json',
          }
      }).then( (r) => {
        console.log(r);
          toast.success(r.data.firstname+" "+r.data.lastname+" is now assigned to project: "+project.name);
          this.myProjects.filter(someobject => someobject._id == project.id).forEach(someobject => someobject.expert = r.data)
              this.refreshKey++;
      }).catch( () => toast.error("An error has occurred during expert assignment"));
    },
    pnameFilter: function(value){
      if (!this.filterProject) {
       return true;
     }
    return value.name.toLowerCase().includes(this.filterProject.toLowerCase());
  },
  customerFilter: function(value){
    if (!this.filterCustomer) {
     return true;
   }
   console.log(value);
   var fullname = value.customer.firstname+" "+value.customer.lastname;
  return fullname.toLowerCase().includes(this.filterCustomer.toLowerCase());
},

  expertFilter: function(value){
    console.log(this.filterExpert);
    if (!this.filterExpert) {
     return true;
   }
   if(this.filterExpert == -1){
       if(!value.expert){
         return true;
       }
       else{
         return false;
       }
   }
   else{
     console.log("EE ",value.expert)
     console.log("FE",this.filterExpert);
     if(!value.expert)return false;
     else return this.filterExpert.$oid == value.expert._id.$oid;
   }
 },

  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
    this.loading = true;
   api.get(process.env.VUE_APP_API_URL+"/restrict/superadmin_projects_open").then( (r) => {
     this.myProjects = r.data;
     console.log(r.data);
   }).catch( (e) => console.log(e));
   api.get(process.env.VUE_APP_API_URL+"/restrict/list_expert").then( (r) => {
     var temp_list = r.data;
     temp_list.map(e => (e.name) = e.firstname+" "+e.lastname);
     this.experts_list= this.experts_list.concat(temp_list);
     console.log(r);
     this.loading = false;
   }).catch( (e) => console.log(e));
 },
 computed: {
    filteredDesserts() {

      var conditions = [];
      this.refreshKey;

      if (this.filterProject) {
        conditions.push(this.pnameFilter);
      }

      if (this.filterCustomer) {
        conditions.push(this.customerFilter);
      }
      //
      if (this.filterExpert) {
        conditions.push(this.expertFilter);
      }

      if (conditions.length > 0) {
        return this.myProjects.filter((project) => {
          return conditions.every((condition) => {
            return condition(project);
          })
        })
      }

      return this.myProjects;
    }
  },

}
</script>
<style scoped >
.myAccount{
  padding-top:50px;
  padding-bottom: 50px;
}
.myAccountContent{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
padding: 50px;
margin-top:50px;
margin-bottom: 50px;

}
.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
text-align:center;
}
.mt50{
  margin-top:50px;
}


.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    display:inline-block;
    margin:auto;
    width:auto;
}

.myAccountContent{
  position:relative;
  padding-top:80px;
}
.mt20{
  margin-top:20px;
}
.mb20{
  margin-bottom: 20px;
}

.disconnect{
  position: absolute;
top: 10px;
right: 10px;
padding: 5px 20px;
color: #3783C5;
border: none;
border-bottom: 1px solid #3783C5;
border-radius: 0;
font-size: 16px;
font-weight: bold;
text-decoration: none;
}
</style>
